import api from '@/services/api2.service'

function jsonConfig(extra = {}) {
    return {
        ...extra,
        headers: { 'Content-Type': 'application/json', ...(extra.headers || {}) },
        transformRequest: [(data) => JSON.stringify(data)]
    }
}

class CustomVocabularyService {
    createList(name, type, organization_id) {
        return api.post('/custom/vocabulary/list', { name, type, organization_id }, jsonConfig())
    }

    getTerms(listId) {
        return api.get(`/custom/vocabulary/terms/${listId}`)
    }

    addTerms(listId, terms) {
        return api.post('/custom/vocabulary/terms', { list_id: listId, terms }, jsonConfig())
    }

    updateTerms(terms) {
        return api.patch('/custom/vocabulary/terms', { terms }, jsonConfig())
    }

    deleteTerms(termIds) {
        // The API's query parser only treats repeated `term_ids` keys as an array;
        // a single key is parsed as a plain string and rejected, so duplicate a lone id.
        const ids = termIds.length === 1 ? [termIds[0], termIds[0]] : termIds
        const query = ids.map(id => `term_ids=${encodeURIComponent(id)}`).join('&')
        return api.delete(`/custom/vocabulary/terms?${query}`)
    }
}

export default new CustomVocabularyService()
